import { Comment } from '@insta-club/models';
import React from 'react';
import CommentItem from './CommentItem';

interface IProps {
    comments: Comment[];
}

const Comments: React.FC<IProps> = ({ comments }) => {
    return (
        <div>
            {comments.map((comment) => (
                <CommentItem key={comment.id} comment={comment} />
            ))}
        </div>
    );
};

export default Comments;

